import React from 'react';
import PropTypes from 'prop-types';

const HeadingCategory = props => {

    const { name, backGroundColorBlock } = props;

    return (
        <section className="my-2 py-2 text-center" style={{ background: backGroundColorBlock }}>
            <h3 className="mb-0 text-white category-title">{name}</h3>
        </section>
    )
}

export default HeadingCategory;

HeadingCategory.propTypes = {
    name: PropTypes.string.isRequired,
    backGroundColorBlock: PropTypes.string.isRequired
}
